import moment from 'moment';
import React from 'react';

interface ChatEntryProps {
  name: string;
  timestamp: string;
  message: string;
  meetingStartTime?: string;
}

const ChatEntry = (props: ChatEntryProps) => {
  const { name, timestamp, message, meetingStartTime } = props;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2">
        <p className="text-customGrey text-xs font-bold">{name}</p>
        {timestamp && meetingStartTime ? (
          <p className="text-customGrey text-xs leading-4 font-light">
            {moment.utc(timestamp, 'HH:mm').local().format('HH:mm')}
          </p>
        ) : (
          'n/a'
        )}
      </div>
      <p className="text-white text-xs leading-5 break-words">{message}</p>
    </div>
  );
};

export default ChatEntry;
